/* eslint-disable import/no-anonymous-default-export */
export default {
  AUCTION: "0xBE9325E1159D79f25fE70E82ad003993e5C14841",
  NFT1: "0x05a7604225E41a66E0c48fD0955AD352BdeB4284",
  MARKETPLACE: "0x44f099a338CC57f8D04923f70b82C1296E9151D4",
  TIMEDMARKETPLACE:'0x675A64b07B5033e778625D3A7e44C1afD5d41fE7',
  R34P:'0xA8D62937604438AbE41bD5f69229f640E3785E6E',
  CLAIMCONTRACT:"",
  CLAIMS:[['CHAIN1',"ADDRESS1",'IMAGE'],['CHAIN2',"ADDRESS2",'IMAGE']],
   RPC_URLS : {
    'CHAIN1': 'https://rpc-for-chain1.com',
    'CHAIN2': 'https://rpc-for-chain2.com',
    
  },
  FORM:'0x2B1B84e72DFcEF46c779cAc9c3B4bfF274bC91e3'
};
